import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function AddServiceModal({ setAddWindowOpen }) {                   //добавление работы, доступное обычному админу, можно добавлять только мойщиков 1 и 2 ранга
  
//const [newService, setNewService]=useState([]);
const [newService, setNewService]=useState({});
const api_url = process.env.REACT_APP_API_URL;
const complex_name = localStorage.getItem('complex_name');
const [saveStatus, setSaveStatus] = useState("");
const [saveButtonDisable, setSaveButtonDisable] = useState(false);                    //по умолчанию кнопка сабмит выключена, проверяем, что номер телефона введен верно, после этого включаем ее 
const [allServiceCategories, setAllServiceCategories] = useState([]);

const durationOptions = [];
  for (let i = 5; i <= 240; i += 5) { // от 5 минут до 4 часов (240 минут)
    const hours = Math.floor(i / 60);
    const minutes = i % 60;
    let label = '';
    if (hours > 0) {
      if (hours === 1) label += '1 час ';
      else if (hours > 1 && hours < 5) label += `${hours} часа `;
      else label += `${hours} часов `;
    }
    if (minutes > 0) {
      label += `${minutes} минут`;
    }
    durationOptions.push({ value: i, label: label.trim() });
}

useEffect(() => {

  async function getServiceCategories() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        body: JSON.stringify({})
      };
      const serviceCategories = await (await fetch(api_url+"/api/allServiceCategories", requestOptions)).json();
      setAllServiceCategories(serviceCategories.map(({service_category_id, service_category_name}) => ({serviceCategoryId: service_category_id, serviceCategoryName: service_category_name})));
  }
  getServiceCategories();
  }, []);

function handleChange(e) {
    setNewService({
      ...newService,
      [e.target.name]: e.target.value
    });
}

async function createService() {
    
    setSaveButtonDisable(true);                               //сразу выключаю кнопку сохранения, чтобы не нажимали дважды

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        //body: JSON.stringify({price_category: newService.priceCategory, car_category: newService.carCategory, service_category: newService.serviceCategory, service_name: newService.serviceName, price: newService.price, salary: newService.salary, min_rank: newService.minRank, admin_salary: newService.admin_salary, detailing: newService.detailing})
        body: JSON.stringify({
                  price_category: newService.priceCategory, 
                  car_category: newService.carCategory, 
                  service_category: newService.serviceCategory, 
                  service_name: newService.serviceName, 
                  price: newService.price, 
                  salary: newService.salary, 
                  min_rank: newService.minRank, 
                  admin_salary: newService.admin_salary, 
                  detailing: newService.detailing,
                  qc_type: newService.qcType || 0,
                  exclude_from_average_check: newService.excludeFromAverageCheck || false,
                  service_duration: newService.serviceDuration
        })
    };

    const saving_visit = await fetch(api_url+"/api/addService", requestOptions);

    const body = await saving_visit.json();
    if (body.message === "Service added successfully!") {
      setSaveStatus("success");
      setTimeout(() => { if (setAddWindowOpen) setAddWindowOpen(false); }, 900);   //автозакрытие после успешного добавления
    }
    else {
      setSaveStatus("error");
      setSaveButtonDisable(false);
    }
}

return (
    <div className='edit-worker-modal'>
    <h1 className="modal-header"> Добавить услугу </h1>
      {/* <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}> */}
      <Box sx={{ maxWidth: 550, margin: 'auto', pt: 3, pb: 3, maxHeight: '80vh', overflowY: 'auto' }}>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="demo-simple-select-label">Категория:</InputLabel>
        <Select
          value={newService.serviceCategory}
          label="Категория:"
          name="serviceCategory"
          fullWidth
          onChange={handleChange}
        >
        {allServiceCategories && allServiceCategories.map(({serviceCategoryId, serviceCategoryName}) => (                           //листим каталог работ
        <MenuItem key={serviceCategoryId} value={serviceCategoryName}> {serviceCategoryName} </MenuItem>
        ))}
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Название</InputLabel>
        <OutlinedInput
          id="service_name"
          name="serviceName"
          value={newService.serviceName}
          onChange={handleChange}
          label="Название"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel>Время на выполнение</InputLabel>
            <Select
                name="serviceDuration"
                value={newService.serviceDuration || ''}
                label="Время на выполнение"
                onChange={handleChange}
            >
              <MenuItem value=""><em>Не указано</em></MenuItem>
              {durationOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="demo-simple-select-label">Выберите тип автомобиля</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="car-type"
                name="carCategory"
                value={newService.carCategory}
                label="Выберите тип автомобиля"
                onChange={handleChange}
            >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={"all"}>Любой</MenuItem>
            </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
                <InputLabel>Минимальный ранг работника</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="min-rank"
                    name="minRank"
                    value={newService.minRank}
                    label="Минимальный ранг работника"
                    onChange={handleChange}
                >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="demo-simple-select-label">Филиал</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="price-category"
                name="priceCategory"
                value={newService.priceCategory}
                label="Филиал"
                onChange={handleChange}
            >
            <MenuItem value={"ohta_only"}>Охта</MenuItem>
            <MenuItem value={"other"}>Кудрово</MenuItem>
            <MenuItem value={"all"}>Все филиалы</MenuItem>
            </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Стоимость</InputLabel>
        <OutlinedInput
          id="service_price"
          name="price"
          value={newService.price}
          onChange={handleChange}
          label="Стоимость"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">ЗП</InputLabel>
        <OutlinedInput
          id="service_salary"
          name="salary"
          value={newService.salary}
          onChange={handleChange}
          label="ЗП"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">ЗП Администратора</InputLabel>
        <OutlinedInput
          id="service_admin_salary"
          name="admin_salary"
          value={newService.admin_salary}
          onChange={handleChange}
          label="ЗП Администратора"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="demo-simple-select-label">Детейлинг</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                defaultValue="no"
                id="detailing"
                name="detailing"
                value={newService.detailing}
                label="Детейлинг"
                onChange={handleChange}
            >
            <MenuItem value={"yes"}>Да</MenuItem>
            <MenuItem value={"no"}>Нет</MenuItem>
            </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="qc-type-select-label">Тип чек-листа</InputLabel>
            <Select
                labelId="qc-type-select-label"
                id="qc_type_select"
                name="qcType" // <-- Важно оставить name для работы handleChange
                value={newService.qcType || 0} // Устанавливаем значение по умолчанию 0
                label="Тип чек-листа"
                onChange={handleChange}
            >
                <MenuItem value={0}>Без чек-листа</MenuItem>
                <MenuItem value={1}>Кузов</MenuItem>
                <MenuItem value={2}>Кузов + Салон</MenuItem>
            </Select>
        </FormControl>

        <Box sx={{ mt: 1.5, mb: 1.5 }}>
        <FormControlLabel
            control={
                <Checkbox
                    checked={!!newService.excludeFromAverageCheck}
                    onChange={e => setNewService({ ...newService, excludeFromAverageCheck: e.target.checked })}
                />
            }
            label="Не учитывать в среднем чеке"
        />
        <Box sx={{ color: 'text.secondary', fontSize: 13, ml: 4 }}>
            Услуга не войдёт в расчёт среднего чека администратора.
        </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mt: 1.5, mb: 1.5 }}>
            <Button variant="outlined" fullWidth onClick={() => setAddWindowOpen && setAddWindowOpen(false)}>Отмена</Button>
            <Button variant="contained"
                fullWidth
                disabled={saveButtonDisable}
                color="success"
                onClick={() => createService()}>Добавить услугу</Button>
        </Box>
        {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введённых данных!</Alert>}
        {saveStatus === "success" && <Alert severity="success">Услуга добавлена</Alert>}
        </Box>
    </div>
)}